import React, { useEffect, useState } from "react";
import { Button, Col, Container, Row } from "react-bootstrap";

import Navbar from "../Navbar/NavBar";
import NewProfileModalComponent from "./NewProfileModalComponent";
import { Profile } from "./types";
import { useRouter } from "helpers/customHooks";
import Profiles from "./Profiles";
import Intensities from "./Intensities";
import {
  useFiltersState,
  useIntensitiesDispatch,
  useUserState,
} from "store/hooks";
import {
  hasEmptyName,
  isCC,
  isNCAAAllSports,
  routeToSpecificScope,
} from "helpers";
import SimpleSelector from "components/Shared/Filters/SimpleSelector";
import TeamSelectorContainer from "../Shared/Filters/TeamsSelector";
import { FILTER_KEYS, SIMPLE_LEAGUE } from "config/constants";
import { useLocation } from "react-router-dom";
import PeriodsTypes from "./PeriodTypes";
import { Intensity, IntensityUI, PeriodType, PeriodTypeUI } from "store/types";
import { usePeriodTypesDispatch } from "store/hooks/periodTypes";
import Loader from "components/Shared/Loader";

/**
 * @param  {} profiles
 * @param  {function} getProfiles
 * @param  {} loading
 * @param  {} messageLoading
 * @param  {} changeScope
 * @param  {} changeOrderColumn
 * @param  {} user
 * @param  {} venues
 */
const PROFILES_TABS = ["profile", "intensities", "periods"];

export default () => {
  const { history, params } = useRouter<{
    params: { teamId: string; tab: string };
  }>();
  const { pathname } = useLocation();
  const specificScope = routeToSpecificScope(pathname);
  const {
    [FILTER_KEYS.TEAM_ID]: filterData = "",
    [FILTER_KEYS.SIMPLE_LEAGUE]: selectedLeague,
  } = useFiltersState(
    specificScope,
    FILTER_KEYS.TEAM_ID,
    FILTER_KEYS.SIMPLE_LEAGUE
  );
  const [activeTab, setActiveTab] = useState(
    PROFILES_TABS.includes(params.tab) ? params.tab : "profile"
  );
  const [modalShow, setModalShow] = useState(false);
  const [selectedProfile, setSelectedProfile] = useState<Profile | null>(null);
  const [isCreate, setIsCreate] = useState(false);
  const [editable, setEditable] = useState(false);
  const [showFilter, setShowFilter] = useState(-1);
  const [intensitiesCopy, setIntensitiesCopy] = useState<IntensityUI[]>([]);
  const [periodTypesCopy, setPeriodTypesCopy] = useState<PeriodTypeUI[]>([]);
    const [showMessg, setShowMessg] = useState(false);
    const [selectedTeam, setSelectedTeam] = useState<string | number>(-1);
  const { updateCustomIntensities } = useIntensitiesDispatch();
  const { updateCustomPeriodTypes } = usePeriodTypesDispatch();
  const tabStyle = (
    isActive: boolean,
    editable: boolean
  ): React.CSSProperties => ({
    opacity: editable
      ? isActive
        ? 0.7 // tab activa cuando editable
        : 0.4 // tabs no activas cuando editable
      : isActive
      ? 1
      : 0.6,
    pointerEvents: editable ? "none" : "auto",
    cursor: editable ? "default" : "pointer",
  });

  const close = () => setShowFilter(-1);
  useEffect(() => {
    setSelectedTeam(-1);
    setShowMessg(true);
  }, [selectedLeague]);

    useEffect(() => {
    setSelectedTeam(filterData);
  }, [filterData]);
  const hasEmptyIntenisty = hasEmptyName(intensitiesCopy);
  const hasEmptyPeriodType = hasEmptyName(periodTypesCopy);
  const handleEditingChange = () => {
    if (activeTab === "intensities" && editable) {
      if (hasEmptyIntenisty) {
        alert("Please fill all intensity names before saving");
        return;
      }
      const cleanPayload: Intensity[] = intensitiesCopy.map(
        ({ id, isEditable, ...rest }, index) => ({
          ...rest,
          pos: index + 1,
        })
      );
      updateCustomIntensities(
        cleanPayload,
        isCC(user) ? filterData : user.teamId
      );
    }
    if (activeTab === "periods" && editable) {
      if (hasEmptyPeriodType) {
        alert("Please fill all period type names before saving");
        return;
      }
      //save PERIOD TYPES
      const cleanPayload: PeriodType[] = periodTypesCopy.map(
        ({ id, isEditable, ...rest }, index) => ({
          ...rest,
          pos: index + 1,
        })
      );
      updateCustomPeriodTypes(
        cleanPayload,
        isCC(user) ? filterData : user.teamId
      );
    }
    setEditable(!editable);
  };

  const handleShow = (caller: string, profile?: Profile) => {
    if (caller === "create") {
      setIsCreate(true);
      setSelectedProfile(null);
    } else {
      setIsCreate(false);
      if (profile) {
        setSelectedProfile(profile);
      }
    }
    setModalShow(true);
  };
  const handleClose = () => setModalShow(false);
  const user = useUserState();
  const leagueValue =
    isCC(user) && selectedLeague?.value
      ? selectedLeague.value
      : { label: user.league, value: user.league };
  return (
    <>
      <Navbar />
      <Container className="container-00">
        <div className="profiles-head">
          <div
            className="profiles-pp-tab"
            style={tabStyle(activeTab === "profile", editable)}
            onClick={() => {
              setActiveTab("profile");
              history.push(`/profiles/profile/`);
            }}
          >
            <h4>Profiles</h4>
          </div>
          <div
            className="intensities-pp-tab"
            style={tabStyle(activeTab === "intensities", editable)}
            onClick={() => {
              setActiveTab("intensities");
              history.push(`/profiles/intensities/`);
            }}
          >
            <h4>Intensities</h4>
          </div>
          <div
            className="periods-pp-tab"
            style={tabStyle(activeTab === "periods", editable)}
            onClick={() => {
              setActiveTab("periods");
              history.push(`/profiles/periods/`);
            }}
          >
            <h4>Period Types</h4>
          </div>
          {(activeTab === "profile" && selectedTeam !== -1) && (
            <div className="profiles-oo">
              <Button
                className="btn-blue"
                onClick={() => handleShow("create")}
                style={{ height: "31px" }}
              >
                Create New Profile
              </Button>
              <NewProfileModalComponent
                show={modalShow}
                onHide={() => handleClose()}
                createMode={isCreate}
                selectedProfile={selectedProfile as Profile}
                selectedTeam={
                  isCC(user) || isNCAAAllSports(user) ? filterData : undefined
                }
                selectedLeague={leagueValue}
              />
            </div>
          )}
          {(activeTab === "intensities" || activeTab === "periods") && (
            <div className={"switch-00 profiles-oo"}>
              <label
                className="label-009"
                onClick={() => {
                  handleEditingChange();
                }}
              >
                {"Editing " + (editable ? "Unlocked" : "Locked")}
              </label>
              <input
                type="checkbox"
                id="editing-practice-manager"
                name="set-name"
                className="switch-input"
                checked={editable}
                onChange={() => handleEditingChange()}
              />
              <label
                htmlFor="editing-practice-manager"
                id="editing-practice-manager-label"
                className="switch-label"
              />
            </div>
          )}
        </div>
        <Row>
          <Col lg={12} xs={12}>
            {(isCC(user) || isNCAAAllSports(user)) && (
              <div
                className="head-filters-01"
                style={
                  editable ? { opacity: "0.5", pointerEvents: "none" } : {}
                }
              >
                {isCC(user) && (
                  <SimpleSelector
                    close={close}
                    show={showFilter === 0}
                    open={() => setShowFilter(0)}
                    type={SIMPLE_LEAGUE}
                  />
                )}
                {(isCC(user) || isNCAAAllSports(user)) && (
                  <TeamSelectorContainer
                    show={showFilter === 1}
                    close={close}
                    open={() => setShowFilter(1)}
                  />
                )}
              </div>
            )}
            <div className="profiles-body-001 profiles-body-00-width" style={!isCC(user)?{height: 'calc(100vh - 113px)'}:{}}>
              {showMessg && selectedTeam === -1 ? 
              <Loader forceMessage="Please select a team."/> :
                activeTab === "profile" && (
                <Profiles
                  handleShow={handleShow}
                  teamId={
                    isCC(user) || isNCAAAllSports(user)
                      ? filterData
                      : user.teamId
                  }
                />
              )}
              {activeTab === "intensities" && (
                <Intensities
                  editable={editable}
                  teamId={
                    isCC(user) || isNCAAAllSports(user)
                      ? filterData
                      : user.teamId
                  }
                  intensitiesCopy={intensitiesCopy}
                  setIntensitiesCopy={setIntensitiesCopy}
                />
              )}
              {activeTab === "periods" && (
                <PeriodsTypes
                  editable={editable}
                  teamId={filterData ? filterData : user.teamId}
                  periodTypesCopy={periodTypesCopy}
                  setPeriodTypesCopy={setPeriodTypesCopy}
                />
              )}
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
};
